module.exports = __webpack_public_path__ + "img/039.cb0c01a5.png";